export default __webpack_public_path__ + "static/media/omor.15230bdf.jpg";